import { notification } from '@surecompanies/core_components'
import { useMutation } from '@tanstack/react-query'
import client from 'enrollment-platform/api/eps.client'

export interface SmokerRatesDiffDataRow {
  id: number
  rowNumber: number
  smokerRateId: string
  year: string
  age: string
  state: string
  issuerId: string
  increaseRate: string
  isActive: string
  diffStatus: string
}

interface UseAnalyzeDiffProps {
  importBatchId: string
  batchType: string
}

interface UseAnalyzeDiffResult {
  mutate: () => void
  data: SmokerRatesDiffDataRow[] | undefined
  isLoading: boolean
  error: any
}

interface DiffResponse {
  rows: SmokerRatesDiffDataRow[]
}

// This function is used to get the diff data from the API
export default function useSmokerRatesDiff({
  importBatchId,
  batchType,
}: UseAnalyzeDiffProps): UseAnalyzeDiffResult {
  const getDiff = async (): Promise<SmokerRatesDiffDataRow[]> => {
    try {
      const result = await client.post<DiffResponse>(
        `/plan-management/${batchType}/diff`,
        {
          importBatchId,
        }
      )
      return result.data.rows
    } catch (error) {
      notification.error({
        message: 'Something went wrong getting the diff',
      })
      throw error
    }
  }

  const { mutate, data, status, error } = useMutation<
    SmokerRatesDiffDataRow[],
    Error,
    void
  >({
    mutationFn: getDiff,
    mutationKey: ['generatediff', importBatchId],
  })

  return {
    mutate,
    data,
    isLoading: status === 'pending',
    error,
  }
}
